import React from 'react';
import './ModalSendforvalidation.css';  
 
const SendforOpenEventModal = ({ show, handleClose, children }) => {
  if (!show) {
    return null;  
  }
 
  return (
    <div className="modal-overlay" >
      <div className="modalcontent" onClick={(e) => e.stopPropagation()}>
       
        <div className="modal-body">
          {children}
        </div>
        <button className="modal-close" onClick={handleClose}>OK</button>
      </div>
    </div>
  );
};
 
export default SendforOpenEventModal;